import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
export default {
  name: 'HelperOffset',
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    classes: function classes() {
      return {
        'v-offset--full-width': this.fullWidth
      };
    },
    styles: function styles() {
      return {
        top: "".concat(0 - this.offset, "px"),
        marginBottom: "".concat(0 - this.offset, "px")
      };
    }
  }
};